/** HingeJoint3D property surface. A key stays `undefined` when unauthored, so the consumer applies Godot's default. */
import { FULL_CIRCLE_LIMITS } from '../joint3d/jointGizmoDrawer';
/** `params[PARAM_LIMIT_UPPER] = Math::PI * 0.5` in hinge_joint_3d.cpp:127, in radians. */
const DEFAULT_UPPER_LIMIT = Math.PI / 2;
/** `params[PARAM_LIMIT_LOWER] = -Math::PI * 0.5` in hinge_joint_3d.cpp:128, in radians. */
const DEFAULT_LOWER_LIMIT = -Math.PI / 2;
/**
 * The limits the gizmo draws (`CreateHingeJointGizmo`, `:478-481`): the authored pair when the limit
 * is on, else lower 0 and upper -1, which draws the full circle.
 */
export function drawnAngularLimits(properties) {
    if (properties['angular_limit/enable'] !== true)
        return FULL_CIRCLE_LIMITS;
    return {
        lower: properties['angular_limit/lower'] ?? DEFAULT_LOWER_LIMIT,
        upper: properties['angular_limit/upper'] ?? DEFAULT_UPPER_LIMIT,
    };
}
//# sourceMappingURL=types.js.map